<template>
  <div>
    <div class="row py-3">
      <div class="col-lg-8 mb-3">
        <input v-model="Text" @keydown.enter.prevent="add(this.Text)" type="text" id="TextInput" class="form-control px-4 py-3" placeholder="New Requirement" maxlength="255">
      </div>

      <div class="col-md">
        <button type="button" class="btn btn-darkblue justify-content-center align-items-center py-3" @click="add(Text)">Add</button>
      </div>
    </div>

    <div
      class="badge d-inline-flex align-items-center bg-primary text-white rounded-pill px-3 py-2 m-1"
      v-for="item in customrequirements"
      :key="item.requirement"
    >
      <input
        :id="item.requirement"
        name="custom_requirements"
        type="hidden"
        :value="item.requirement"
      />
      <span class="me-2">{{ item.requirement }}</span>
      <button
        type="button"
        class="btn-close btn-close-white p-0 m-0"
        style="font-size: 0.65rem"
        @click="del(item)"
      ></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomRequirements',
  props: {
    customrequirements: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      Text: "",
    }
  },
  methods: {
    add: function(text) {
      if(text !== "") {
        this.customrequirements.push({requirement: text});
        this.$emit('updatecustomrequirements', this.customrequirements);
        this.Text = "";
      }
    },
    del: function(requirement) {
      this.customrequirements.splice(this.customrequirements.indexOf(requirement), 1);
      this.$emit('updatecustomrequirements', this.customrequirements);
    }
  },
}
</script>

<style lang="scss">
@import '@/scss/variables';

.alert {
  background: $primary-200;
  
  .btn-close {
    background: transparent url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%2303B6ED'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e") center/1em auto no-repeat;
  }
}
</style>
